import React from 'react';
import { InformationSection } from '../../Profile/components/InformationSection';
import { ParticipantInputByName } from '../../Profile/components/ParticipantInputByName';
import {
  ParticipantFieldCategory,
  useParticipantFieldsCategory,
} from '@app/api';

interface Props {
  displayedFields?: string[];
}
const allFields = ['countryKey', 'city', 'postalCode', 'locales'];

export const Location = ({ displayedFields = allFields }: Props) => {
  const categoryConfig = useParticipantFieldsCategory(
    ParticipantFieldCategory.GEOLOCATION,
  );
  if (!categoryConfig) {
    return null;
  }

  return (
    <InformationSection
      title={categoryConfig.title}
      icon="ri-map-pin-2-line"
      iconColor="blue"
      description={categoryConfig.description}
    >
      {allFields.map(
        (fieldName) =>
          displayedFields.includes(fieldName) && (
            <ParticipantInputByName key={fieldName} fieldName={fieldName} />
          ),
      )}
    </InformationSection>
  );
};
